module.exports = __webpack_public_path__ + "img/violet_120.8c854a48.png";